import React, { Fragment, useState } from 'react';
import { Modal, Icon } from 'antd';

interface ImagePreviewProps {
  src: string;
}

/**
 * This Class show an image with actual ratio
 * @param props
 * @constructor
 */
const ImagePreview:React.FC<ImagePreviewProps> = props => {
    const [visible, setVisible] = useState(false);

    return(
      <span className={`ignore-inner-click`}>
        <Icon type="fullscreen" onClick={() => setVisible(true)}/>
        <Modal className={`image-preview-modal`} visible={visible} footer={null} onCancel={() => setVisible(false)}>
          <img alt="example" style={{ width: '100%' }} src={props.src} />
        </Modal>
      </span>
    )

};

export default ImagePreview